var map = {
	"./en/common": 1807,
	"./en/common.json": 1807,
	"./en/seo": 63351,
	"./en/seo.json": 63351,
	"./en/unit": 3891,
	"./en/unit.json": 3891,
	"./es-ES/common": 65703,
	"./es-ES/common.json": 65703,
	"./es-ES/seo": 56387,
	"./es-ES/seo.json": 56387,
	"./es-ES/unit": 34781,
	"./es-ES/unit.json": 34781
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71045;